export const AdminSections = [
  'reports',
  'chats',
  'transcripts',
  'eval',
  'tokens',
  'features',
  'invoicing',
  'routes',
  'snapshots',
  'curated-templates',
  'long-running-tasks',
] as const

export type Section = (typeof AdminSections)[number]

const defaultSection: Section = 'reports'

export const getSectionFromHash = (hash: string): Section => {
  const match = hash.match(/admin-app\/([^/?]+)/)
  const candidate = match?.[1] as Section | undefined
  if (candidate && AdminSections.includes(candidate)) {
    return candidate
  }
  return defaultSection
}

export const buildAdminAppHash = (section: Section): string => {
  return `#!/admin-app/${section}`
}
